import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import {on, Options} from "../utils/decorators";
import {getParams} from "../utils/get-params";
import * as Headroom from "headroom.js";

@Options({
    template: false,
    ui: {
        selectFilter: "[data-js-ui=select-filter]",
        filterForm: "[data-js-ui=filter-form]",
        anchorLink: "[data-js-ui=anchor-link]",
        tabsWrapper: "[data-js-ui=tabs-wrapper]",
    }
})
export default class DeeplinkFilterView extends Marionette.View<Backbone.Model>{
    eleOffset  = 0;
    elements;
    activeId;
    loaded = false;
    onRender(){
        this.initHeadroom();
        $(window).bind('scroll', $.proxy(this.onScroll, this));
        this.eleOffset = this.$el.offset().top;
        this.elements = $('.deep-link-item');
        $(window).scroll();
        this.onLoad();
    }

    onLoad() {
        let scope = this;

        if (!this.loaded) {
            setTimeout(() => {
                if (document.readyState === 'complete') {
                    scope.loaded = true;
                    const id = window.location.hash.slice(1);
                    const yOffset = -100;
                    const element = document.getElementById(id);
                    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

                    window.scrollTo({top: y, behavior: 'smooth'});
                }

                scope.onLoad();
            }, 100);
        }
    }

    onDestroy() {
        $(window).off('scroll');
    }

    initHeadroom() {
        const el = this.el;
        const options = {
            offset: 150,
            tolerance: 0,
            classes: {
                initial: "headroom",
                pinned: "headroom--pinned",
                unpinned: "headroom--unpinned",
            }
        };

        new Headroom(el, options).init();
    }
    updateActive(newId){
        if (newId!=null && this.activeId!=newId){
            this.activeId=newId;
            this.ui.anchorLink.removeClass("is-active");
            this.ui.anchorLink.filter(this.activeId + "-anchor").addClass("is-active");
        }

    }
    onScroll(e){
        let menuOffset = 150;
        let scrollpos = $(window).scrollTop();
        if (this.eleOffset < (scrollpos + menuOffset)){
            this.$el.addClass("stuck");
        }else{
            this.$el.removeClass("stuck");
        }
    }


    @on("click @ui.anchorLink")
    onClickLink(e) {
        if ($(e.target).attr("hash_key")){
            e.preventDefault();
            this.setHash($(e.target).attr("hash_key"));
        }
    }
    @on("change @ui.selectFilter")
    onSelectFilterChange(e) {
        if (e.target.value){
            this.setHash(e.target.value);
        }

    }
    setHash(target){
        if (target.length) {
            this.updateActive(target);
            var $target = $(target);
            let scope = this;
            $(window).unbind('scroll');
            $('html, body').animate({
                scrollTop: $target.offset().top
            }, 1000, function () {
                $(window).bind('scroll', $.proxy(scope.onScroll, scope));
                $(window).scroll();
                window.location.hash = target;
                $target.focus();
                if ($target.is(":focus")) {
                    return false;
                } else {
                    $target.attr('tabindex', '-1');
                    $target.focus();
                };
            });
        }
    }
}



// WEBPACK FOOTER //
// ./@modules/views/deeplink-filter-view.ts